import ReactTable from "react-table";
import React, { Component } from "react";
import "react-table/react-table.css";
import { fetchMethod } from "../../FetchMethod";
import "./reactTable.css";
//import { DotLoader } from "react-spinners";
import { SemipolarLoading } from "react-loadingg";

const shouldComponentUpdate = (prevProps, nextProps, prevState, nextState) => {
  return (
    JSON.stringify(prevProps) !== JSON.stringify(nextProps) ||
    JSON.stringify(prevState) !== JSON.stringify(nextState)
  );
};

export default class ReactTableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      limit: 50,
      offset: 50,
      pageNo: 0,
      pageSize: 50,
      pageSizeOptions: [50, 100, 200, 500],
      totalCount: 0,
      listData: []
    };
  }

  componentDidMount() {

    this.setState({ loading: true });
    this.searchFetch(this.state.limit, this.state.offset);
  }

  searchFetch = (limit, offset) => {
    
    return this.props.clickToSearch
      ? this.setState(
          {
            pageNo: this.state.pageNo,
            limit: this.state.limit,
            offset: this.state.limit
          },
          () => {
            this.fetchQuery(this.state.limit, this.state.offset);
          }
        )
      : this.setState({ pageNo: this.state.pageNo }, () => this.fetchQuery(limit, offset));
  };

  fetchQuery(LIMIT, OFFSET) {
    const filter = this.props.filter;
   

    fetchMethod(this.props.query(LIMIT, OFFSET), filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        this.setListData(responseAsJson);
        this.setState({ loading: false });
      })
      .catch(e => {
        console.log(e);
        this.setState({ loading: true });
      });
   
  }

  onPageLimitChange = limit => {
    this.setState({
      limit: this.state.limit,
      offset: this.state.offset,
      pageNo: 0,
      pageSize: this.state.pageSize
    });
    let pageNo = "";
    this.setState({ limit, pageSize: limit }, () => {
      pageNo = this.state.pageNo + 1;
      let offset = this.state.limit;
      this.searchFetch(this.state.limit, offset * pageNo);
      this.setState({ offset: offset * pageNo });
    });
  };

  onPageNumberChange = page => {
    let limit = this.state.limit;
    let offset = limit * (page + 1);
    this.searchFetch(limit, offset);
    this.setState({ pageNo: page, offset });
  };

  setListData(listData) {
    this.props.setData(listData);
    this.props.setLimit(this.state.limit);
    this.props.setOffset(this.state.offset);
  }

  render() {
    if (!this.props.listData || this.state.loading) {
      return (
        <div className="spinner">
          <SemipolarLoading size={70} color={"#3865dd"} />
        </div>
      );
    }

    let pageSize = this.state.pageSize;
    let { listConfig, listData, totalCount } = this.props;
    let reactTableBlankMessage = "";
    if (this.props.clickToSearch) {
      if (listData.length) {
        reactTableBlankMessage = listData.length;
      }
    } else {
      reactTableBlankMessage = 0;
    }

    return (
      <div>
        <div className={this.props.className}>
          {listData || !this.state.loading ? (
            <ReactTable
              classsName="-striped -highlight"
              manual
              columns={listConfig}
              data={listData}
              pageSize={pageSize}
              minRows={listData.length > 0 ? 0 : 2}
              showPagination={true}
              defaultPageSize={10}
              pageSizeOptions={this.state.pageSizeOptions}
              pages={Math.ceil(totalCount / pageSize)}
              onPageSizeChange={this.onPageLimitChange}
              onPageChange={this.onPageNumberChange}
              sortable={false}
              page={this.state.pageNo}
          
              NoDataComponent={() => (
                <div className="rt-noData">
                  {reactTableBlankMessage !== 0 ? (
                    <span>No matching results found </span>
                  ) : (
                    <span>No data found</span>
                  )}
                </div>
              )}
            />
          ) : (
            <div className="spinner">
              <SemipolarLoading size={70} color={"#004379"} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
